import { useRouteError, isRouteErrorResponse, Navigate } from 'react-router-dom';

const RootBoundary = () => {
    const error = useRouteError();

    if (isRouteErrorResponse(error)) {
        console.warn('ROUTER ERROR');

        if (error.status === 404) {
            console.warn('ROUTER | PAGE NOT FOUND');
        }
    }

    return <Navigate to="/" />;
};

export default RootBoundary;
